import { JSX } from 'react'

import { IconProps } from '../../icon'

const Chatbot: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M19.8125 26.8125C19.2947 26.8125 18.875 27.2322 18.875 27.75V29.625C18.875 30.1428 19.2947 30.5625 19.8125 30.5625C20.3303 30.5625 20.75 30.1428 20.75 29.625V27.75C20.75 27.2322 20.3303 26.8125 19.8125 26.8125Z'
      fill='black'
    />
    <path
      d='M29.1875 30.5625C29.7053 30.5625 30.125 30.1428 30.125 29.625V27.75C30.125 27.2322 29.7053 26.8125 29.1875 26.8125C28.6697 26.8125 28.25 27.2322 28.25 27.75V29.625C28.25 30.1428 28.6697 30.5625 29.1875 30.5625Z'
      fill='black'
    />
    <path
      d='M25.5 14.625H35.75C36.2677 14.625 36.6875 14.2053 36.6875 13.6875C36.6875 13.1697 36.2677 12.75 35.75 12.75H25.5C24.9822 12.75 24.5625 13.1697 24.5625 13.6875C24.5625 14.2053 24.9822 14.625 25.5 14.625Z'
      fill='black'
    />
    <path
      d='M40.5 19V12.0625C40.5 9.82244 38.6776 8 36.4375 8H24.8125C22.5724 8 20.75 9.82244 20.75 12.0625V19.3125H19.5C16.0733 19.3125 13.1994 21.7231 12.4841 24.9375H12.3125V19.1512C13.4037 18.7642 14.1875 17.7222 14.1875 16.5C14.1875 14.9492 12.9258 13.6875 11.375 13.6875C9.82419 13.6875 8.5625 14.9492 8.5625 16.5C8.5625 17.7222 9.34631 18.7642 10.4375 19.1512V25.0776C9.31394 25.4464 8.5 26.5046 8.5 27.75V31.5C8.5 33.0508 9.76169 34.3125 11.3125 34.3125H12.4704C13.1623 37.5581 16.0511 40 19.5 40H29.5C32.9489 40 35.8377 37.5581 36.5296 34.3125H37.6875C39.2383 34.3125 40.5 33.0508 40.5 31.5V27.75C40.5 26.1992 39.2383 24.9375 37.6875 24.9375H36.5156C36.3699 24.2825 36.1334 23.6514 35.8126 23.0625H36.4375C38.6776 23.0625 40.5 21.2401 40.5 19ZM22.625 12.0625C22.625 10.8563 23.6063 9.875 24.8125 9.875H36.4375C37.6437 9.875 38.625 10.8563 38.625 12.0625V19C38.625 20.2062 37.6437 21.1875 36.4375 21.1875H25.4375C25.2919 21.1875 25.1484 21.2214 25.0182 21.2864L22.625 22.4831V12.0625ZM11.375 15.5625C11.8919 15.5625 12.3125 15.9831 12.3125 16.5C12.3125 17.0169 11.8919 17.4375 11.375 17.4375C10.8581 17.4375 10.4375 17.0169 10.4375 16.5C10.4375 15.9831 10.8581 15.5625 11.375 15.5625ZM10.375 31.5V27.75C10.375 27.2331 10.7956 26.8125 11.3125 26.8125H12.3125V32.4375H11.3125C10.7956 32.4375 10.375 32.0169 10.375 31.5ZM38.625 27.75V31.5C38.625 32.0169 38.2044 32.4375 37.6875 32.4375H36.6875V26.8125H37.6875C38.2044 26.8125 38.625 27.2331 38.625 27.75ZM34.8125 26.5V32.8125C34.8125 35.7418 32.4293 38.125 29.5 38.125H19.5C16.5707 38.125 14.1875 35.7418 14.1875 32.8125V26.5C14.1875 23.5707 16.5707 21.1875 19.5 21.1875H20.75V24C20.75 24.6957 21.4839 25.15 22.1067 24.8385L25.6588 23.0625H33.5489C34.3638 24.0215 34.8125 25.2378 34.8125 26.5Z'
      fill='black'
    />
    <path
      d='M25.5 18.375H35.75C36.2677 18.375 36.6875 17.9553 36.6875 17.4375C36.6875 16.9197 36.2677 16.5 35.75 16.5H25.5C24.9822 16.5 24.5625 16.9197 24.5625 17.4375C24.5625 17.9553 24.9822 18.375 25.5 18.375Z'
      fill='black'
    />
    <path
      d='M21.6875 33.375C21.6875 33.8928 22.1072 34.3125 22.625 34.3125H26.375C26.8927 34.3125 27.3125 33.8928 27.3125 33.375C27.3125 32.8572 26.8927 32.4375 26.375 32.4375H22.625C22.1072 32.4375 21.6875 32.8572 21.6875 33.375Z'
      fill='black'
    />
  </svg>
)

export default Chatbot
